/** Short-lived PDP product payload (avoids duplicate GET after StorefrontSingleSegmentPage resolver). */

const TTL_MS = 60_000;
const store = new Map();

function cacheKey(slug) {
  return String(slug || '')
    .trim()
    .toLowerCase();
}

export function setPrefetchedPdpProduct(slug, product) {
  const key = cacheKey(slug);
  if (!key || !product) return;
  store.set(key, { product, at: Date.now() });
}

export function takePrefetchedPdpProduct(slug) {
  const key = cacheKey(slug);
  if (!key) return null;
  const row = store.get(key);
  if (!row) return null;
  if (Date.now() - row.at > TTL_MS) {
    store.delete(key);
    return null;
  }
  store.delete(key);
  return row.product;
}
